import { isMissingAuth } from '@takeshape/schema';
import { isHttpsUri, isWebUri } from 'valid-url';
import { hasEveryKey } from "./has.js";
export function hasValidEndpoint(serviceConfig) {
    const endpoint = serviceConfig.options?.endpoint;
    return (typeof endpoint === 'string' &&
        (serviceConfig.authenticationType === 'none'
            ? isWebUri(endpoint) !== undefined
            : isHttpsUri(endpoint) !== undefined));
}
export function isCompleteGraphQLConfig(serviceConfig) {
    return !isMissingAuth(serviceConfig) && hasValidEndpoint(serviceConfig);
}
export function isServiceConfig(name, keys) {
    return (serviceConfig) => serviceConfig.provider === name && hasEveryKey(keys)(serviceConfig);
}
